import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-dialog-canvas',
  templateUrl: './dialog-canvas.component.html',
  styleUrls: ['./dialog-canvas.component.scss']
})
export class DialogCanvasComponent implements OnInit {

  isOpened: boolean;
  application: AppComponent;
  state: string;
  payload: object = {};
  constructor(public dialogRef: MatDialogRef<DialogCanvasComponent>,
              @Inject(MAT_DIALOG_DATA) public data) {
    if (data) { // input data through dialog
      this.application = data.application;
      this.state = data.state;
      this.payload = data.payload ? data.payload : {};
    }
  }

  ngOnInit(): void {
  }

  public onSuccessWithPayload(data: object): void {
    this.dialogRef.close(data);
  }

  public onSuccess(): void {
    this.dialogRef.close(true);
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

}
